import { render, staticRenderFns } from "./MerchantSearch.vue?vue&type=template&id=afbe8b76&"
import script from "./MerchantSearch.vue?vue&type=script&lang=js&"
export * from "./MerchantSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports